
import ApplicationTitle from '../../components/ApplicationTitle';
import TwoInputs from '../../components/input_fields/TwoInputs'
import StackedTitle from '../../components/form_titles/StackedTitle';
import DoubleButton from '../../components/buttons/DoubleButton';
import ThreeInptus from '../../components/input_fields/ThreeInputs';
import TextSelectInput from '../../components/input_fields/TextSelectInput';
import ProgressBar from '../../components/progress/ProgressBar';

import validator from "validator";
import React, { useState } from "react";
import { data } from '../../constants';
import TextInput from '../../components/input_fields/TextInput';
import InputSelectSearch from '../../components/input_fields/seachable/InputSelectSearch';

export default function Step5({ nextStep, nextHalfStep, handleFormData, prevStep, values, validation, color }) {

  // Required
  const [busStreetError, setBusStreetError] = useState(false)
  const [busPhoneError, setBusPhoneError] = useState(false)
  const [busEmailError, setBusEmailError] = useState(false)
  const [busCityError, setBusCityError] = useState(false)
  const [busStateError, setBusStateError] = useState(false)
  const [busZipError, setBusZipError] = useState(false)
  const [otherLocationError, setOtherLocationError] = useState(false)

  // Not Required
  const [busFaxError, setBusFaxError] = useState(false)
  const [busStreet2Error, setBusStreet2Error] = useState(false)

  const submitFormData = (e) => {
    e.preventDefault();

    if (validation) {
      // Business Street Error
      if (validator.isEmpty(values.busStreet)) {
        setBusStreetError(true)
        return
      } setBusStreetError(false)

      // Business Phone Error
      if (!validator.isMobilePhone(values.busPhone)) {
        setBusPhoneError(true)
        return
      } setBusPhoneError(false)

      // Business Email Error
      if (!validator.isEmail(values.busEmail)) {
        setBusEmailError(true)
        return
      } setBusEmailError(false)

      // Business City Error
      if (validator.isEmpty(values.busCity)) {
        setBusCityError(true)
        return
      } setBusCityError(false)

      // Business State Error
      if (!data.states.includes(values.busState)) {
        setBusStateError(true)
        return
      } setBusStateError(false)

      // Business Zipcode Error
      if (!validator.isNumeric(values.busZip) || values.busZip.length !== 5) {
        setBusZipError(true)
        return
      } setBusZipError(false)
    }


    // Other Location Error
    // if (validator.isEmpty(values.otherLocation)) {
    //   setOtherLocationError(true)
    //   return
    // } setOtherLocationError(false)

    if (values.otherLocation === 'yes') {
      nextHalfStep()
    }
    if (values.otherLocation === 'no' || values.otherLocation === "" || values.otherLocation === undefined) {
      nextStep();
    }
  }

  return (
    <div className="bg-white-900 dark:bg-white-900">
      <div className="items-center px-8 py-8 my-10 mx-auto w-fit py-0">
        {/* <ApplicationTitle 
            mainTitle = "Bipsypay Merchant Application"
            subTitle = "Complete the form below to begin your Bipsypay merchant application"
        /> */}
        <ProgressBar
          progress="60%"
          color = {color}
        />
        <div className="bg-white rounded-lg shadow dark:border width-screen xl:p-0">
          <div className="p-6 space-y-1 sm:p-8">
            <StackedTitle
              color = {color}
              mainTitle="Share your"
              colorTitle="business location."
              subText="Enter the physical address where merchant transactions occur (No PO Box)."
              modalTitle="Why do you need this..."
              modalDesc="The Card Brands (Visa/ MasterCard) rules require merchants to submit complete data, including name, type of business, and merchant location with each transaction. Providing the proper information is important for: Cardholder recognition, and reducing unnecessary cardholder disputes, Accurate risk assessment and authorization decisions, reducing additional risk to all participants in the Visa system Accurate assessment of fees and interchange."
            />
            <form className="space-y-4" onSubmit={submitFormData}>
              <TwoInputs
                color = {color}
                placeholder1="Street Address" id1="stree_add" name1="busStreet" type1="text" value1={values.busStreet}
                error1={busStreetError} message1={"Please provide a street address."}
                handleInputChange1={handleFormData}
                placeholder2="Phone Number (123) 456-7890" id2="busPhone" name2="busPhone" type2="text" value2={values.busPhone}
                error2={busPhoneError} message2={"Please enter a valid phone number."}
                handleInputChange2={handleFormData}
              />
              <TwoInputs
                color = {color}
                placeholder1="Street Address Line 2" id1="address2" name1="busStreet2" type1="text" value1={values.busStreet2}
                handleInputChange1={handleFormData}
                placeholder2="Business Email Address" id2="email" name2="busEmail" type2="email" value2={values.busEmail}
                error2={busEmailError} message2={"Please enter a valid email address."}
                handleInputChange2={handleFormData}
              />

              <InputSelectSearch
                color = {color}
                placeholder1="City" id1="city" type1="text" name1="busCity" value1={values.busCity}
                error1={busCityError} message1={"Please enter a city."}
                handleInputChange1={handleFormData}
                placeholder2="State" id2="state" type2="text" name2="busState" value2={values.busState}
                error2={busStateError} message2={"Please enter a valid State."}
                handleInputChange2={handleFormData}
              ></InputSelectSearch>

              {/* <ThreeInptus 
                    placeholder1 = "City" id1 = "city" type1 = "text" name1 = "busCity" 
                    error1 = {busCityError} message1 = {"Please enter a city."}
                    handleInputChange1={handleFormData}
                    placeholder2 = "State" id2 = "state" type2 = "text" name2 = "busState" 
                    error2 = {busStateError} message2 = {"Please enter a valid State."}
                    handleInputChange2={handleFormData}
                    placeholder3 = "Fax Number (123) 456-7890" id3 = "fax" type3 = "text" name3 = "busFax" 
                    handleInputChange3={handleFormData}
                /> */}

              <TextInput
                color = {color}
                placeholder="Zipcode" id="bus_zip" type="Text" name="busZip" value={values.busZip}
                error={busZipError} message={"Please provide your 5 digit zipcode."}
                handleInputChange={handleFormData}
              />

              {/* <TextSelectInput 
                    color = {color}
                    placeholder1 = "Zipcode" id1 = "bus_zip" type1 = "Text" name1 = "busZip" 
                    error1 = {busZipError} message1 = {"Please provide your 5 digit zipcode."}
                    handleInputChange1={handleFormData}
                    placeholder2 = "Do you have another location?" id2 = "other_location" name2 = "otherLocation"  options = {["yes", "no"]}
                    error2 = {otherLocationError} message2 = {"Do you have another location?"}
                    handleInputChange2={handleFormData}
                /> */}

              <DoubleButton color = {color} prevStep={prevStep} />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}